import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

const table_config = {
  key_column: "id",
  page_size: 10,
  length_menu: [10, 20, 50],
  show_filter: true,
  show_pagination: true,
  button: {
    excel: false,
    print: false,
  },
  language: {
    loading_text: "Please be patient while data loads...",
  },
};

const initial_value = [
  {
    created_at: "23-03-2022 03:08 PM",
    quantity: "20",
    file_path: "c://new",
  },
];

const animatedComponents = makeAnimated();
let myModal: any;

export default function ModalViewFile(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [final_data, SetFinalData] = useState(initial_value);

  useEffect(() => {
    console.log("ModalViewFile On mount :", props);
    let myModal1: any = document.getElementById("ViewFileModal");
    myModal1.addEventListener("hidden.bs.modal", function (event: any) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelACompany On open :", props);

      myModal = new bootstrap.Modal(
        document.getElementById("ViewFileModal"),
        {}
      );
      myModal.show();
      SetFinalData(props.data);
      // SetCompany(props.data.company_data);
    }
  }, [props.open]);

  return (
    <div
      className="modal fade"
      id="ViewFileModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h5 className="  modal-title" id="ModalLabel">
                Final Out Details
              </h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {final_data.length > 0 ? (
              final_data.map((f_ele: any, f_index: any) => (
                <div className="row" key={f_index}>
                  {/* file path */}
                  <div className="mb-3 col-12">
                    <h6>File path :{f_ele.file_path}</h6>
                  </div>
                  {/* quantity */}
                  <div className="mb-3 col-sm-6">
                    <p className="text-dark mb-2">
                      Quantity : {f_ele.quantity}
                    </p>
                  </div>

                  {f_ele.hasOwnProperty("notes") ? (
                    <div className="mb-3 col-12">
                      <p className="text-dark mb-2">Notes : {f_ele.notes}</p>
                    </div>
                  ) : null}

                  {/* Created at */}
                  <div className="col-sm-6 md-text-end">
                    <small className="text-gray">
                      <img
                        src={require("../../../assets/icon/svg/clock1.svg")}
                        className="pe-2 action-img"
                      />
                      {f_ele.created_at}
                    </small>
                  </div>
                </div>
              ))
            ) : (
              <div>No Final Out</div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
